export default "__VITE_ASSET__aomUYvul__"